// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_TO_MAGAZINE = "Prida\u0165 do magaz\u00ednu";
export const BLOCK_USER = "Zablokova\u0165 pou\u017e\u00edvate\u013ea";
export const BLOG_REPORT_POST = "Nahl\u00e1si\u0165 pr\u00edspevok";
export const CHANGE_DATE_TITLE_AND_DESCRIPTION = "Zme\u0148 n\u00e1zov a popis";
export const DELETE_ALBUM = "Zma\u017e album";
export const REMOVE_FROM_FEED = "Odstr\u00e1ni\u0165 z feedu";
export const REMOVE_FROM_MAGAZINE = "Odstr\u00e1ni\u0165 z magaz\u00ednu";
export const REORDER_PHOTOS = "Zme\u0148 poradie fotiek";
export const RETURN_TO_FEED = "Vr\u00e1ti\u0165 do feedu";
export const SEND_HEART_TO_username = "Po\u0161li srdie\u010dko %(username)s";
export const SHOW_USERS_WHO_LIKED_THIS_POST = "Zobraz u\u017e\u00edvate\u013eky, ktor\u00fdm sa to p\u00e1\u010di";
